import React from 'react';
import { Briefcase, MapPin, Calendar } from 'lucide-react';

const Experience = ({ data, language, translations }) => {
  const profileData = data || JSON.parse(localStorage.getItem('portfolioData') || '{}');
  const t = translations || {};
  
  // Get translated experience data
  const experienceData = t.experienceData || profileData.experience;

  return (
    <div className="content-section">
      <h2 className="section-title">{t.experience || 'Experiencia Laboral'}</h2>
      <div className="section-content">
        {experienceData.map((exp, index) => (
          <div key={exp.id || index} className="experience-card">
            <div className="card-header">
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <Briefcase size={20} color="var(--steel-dim)" />
                  <h3 className="card-title">{exp.position}</h3>
                </div>
                <p className="card-subtitle">{exp.company}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '10px', flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <MapPin size={16} color="var(--text-secondary)" />
                    <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>{exp.location}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Calendar size={16} color="var(--text-secondary)" />
                    <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>{exp.period}</span>
                  </div>
                </div>
              </div>
              {exp.current && (
                <div style={{ 
                  background: 'var(--cyan-primary)', 
                  color: 'var(--bg-primary)', 
                  padding: '4px 12px', 
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontWeight: '600'
                }}>
                  {t.currentStatus || 'ACTUAL'}
                </div>
              )}
            </div>

            <ul className="responsibilities-list">
              {exp.responsibilities.map((resp, index) => (
                <li key={index}>{resp}</li>
              ))}
            </ul>

            {exp.technologies && (
              <div className="tech-tags">
                {exp.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
